"use client"

import * as React from "react"
import { Eye, EyeOff } from "lucide-react"

import { cn } from "@/lib/utils"
import styles from "./secret-input.module.css"

type SecretInputProps = React.ComponentProps<"input"> & {
  visibilityLabel?: string
}

function SecretInput({ id, className, style, disabled, visibilityLabel = "password", ...props }: SecretInputProps) {
  const generatedId = React.useId()
  const inputId = id ?? generatedId
  const [visible, setVisible] = React.useState(false)
  const actionLabel = `${visible ? "Hide" : "Show"} ${visibilityLabel}`

  return (
    <span className={styles.field} data-slot="secret-input" style={{ color: style?.color }}>
      <input
        {...props}
        id={inputId}
        type={visible ? "text" : "password"}
        disabled={disabled}
        className={cn(styles.input, className)}
        style={{ ...style, paddingInlineEnd: "3rem" }}
      />
      <button
        type="button"
        className={styles.toggle}
        aria-label={actionLabel}
        aria-controls={inputId}
        title={actionLabel}
        disabled={disabled}
        onMouseDown={event => event.preventDefault()}
        onClick={() => setVisible(value => !value)}
      >
        {visible ? <EyeOff size={18} aria-hidden="true" /> : <Eye size={18} aria-hidden="true" />}
      </button>
    </span>
  )
}

export { SecretInput }
export type { SecretInputProps }
